import { OPERATIONS_BACKEND_URL } from '@/config'
import { AxiosError } from 'axios'

export enum ServerStatusCode {
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  Conflict = 409,
  PreconditionFailed = 412,
  UprocessableEntity = 422,
  InternalServerError = 500,
  NotImplemented = 501,
  BadGateway = 502,
  ServiceUnavailable = 503,
  GatewayTimeout = 504
}

export const UNKNOWN_NETWORK_ERROR = 'Unknown network error'

export function isControlledBackendError(error: AxiosError): boolean {
  return error.response?.status === ServerStatusCode.BadRequest
}

export function isNetworkError(error: AxiosError): boolean {
  return !error.response && error.message === UNKNOWN_NETWORK_ERROR
}

export function isUnauthorizedError(error: AxiosError): boolean {
  return [ServerStatusCode.Unauthorized, ServerStatusCode.Forbidden].includes(
    error.response?.status
  )
}

export function isConcurrentUpdateError(error: AxiosError): boolean {
  return error.response?.status === ServerStatusCode.Conflict
}

export function isUnauthorizedBySennder(error: AxiosError): boolean {
  const isSennderRequest = Boolean(error.config?.url?.includes(OPERATIONS_BACKEND_URL))
  return isUnauthorizedError(error) && isSennderRequest
}

export function isServerError(error: AxiosError): boolean {
  return error.response?.status === ServerStatusCode.InternalServerError
}

export function isServerErrorGeneric(error: AxiosError): boolean {
  return [
    ServerStatusCode.NotImplemented,
    ServerStatusCode.BadGateway,
    ServerStatusCode.ServiceUnavailable,
    ServerStatusCode.GatewayTimeout
  ].includes(error.response?.status)
}

export function applyCustomErrorConfig() {
  return {
    customClass: {
      closeButton: 'modal-alert__close',
      content: 'modal-alert__content',
      title: 'modal-alert__title'
    },
    showConfirmButton: false,
    showCloseButton: true,
    padding: '3em 1em 4em 1em',
    imageUrl: require('@/assets/svgs/alert_error_icon.svg'),
    imageAlt: 'alert error image',
    width: 500
  }
}

export function applyCustomErrorConfigOverrides(overrides) {
  return function() {
    return {
      ...applyCustomErrorConfig(),
      ...overrides
    }
  }
}
